import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_CONNECTOR_TYPE, UPDATE_CONNECTOR_TYPE } from 'actions/connectorType';
import Select from 'components/inputs/Select';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';

const ConnectorTypeSchema = Yup.object().shape({
  name: Yup.string()
    .required('Connector name is required')
    .strict(true)
    .trim('Space is not allowed')
    .max(100, 'Text limit should be less than 100 characters.'),
  connector_mode: Yup.string().required('Connector mode is required'),
  connector_standard: Yup.string().required('Connector standard is required'),
});

const ConnectorTypeForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const connectorTypeDetail = useSelector((state) => state.connectorType.connectorTypeDetail);
  const isLoading = useSelector((state) => state.connectorType.isLoading);

  const addConnectorType = useCallback((data) => {
    dispatch({
      type: CREATE_CONNECTOR_TYPE,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateConnectorType = useCallback((data) => {
    dispatch({
      type: UPDATE_CONNECTOR_TYPE,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const initialValues = isEdit
    ? { ...connectorTypeDetail }
    : {
        name: '',
        icon: 'http://linkto/imafile.jpg',
        connector_mode: '',
        connector_standard: '',
        description: '',
      };
  return (
    <React.Fragment>
      <div className="connectorType-form-page__main">
        <Card>
          <div className="connectorType-form-header__block">
            <div className="connectorType-header-name">
              <span>{isEdit ? 'Edit' : 'Add'} Connector Type</span>
            </div>
            <div className="close___btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
          </div>
          <div className="connectorType-form-body__block">
            <div className="connectorType-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={ConnectorTypeSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updateConnectorType(values);
                  } else {
                    addConnectorType(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, setFieldValue, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={12}>
                        <TextInput
                          isRequired
                          label="Connector Type"
                          placeholder="Connector type"
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                      <Col lg={12}>
                        <Select
                          isRequired
                          label="Connector Mode"
                          options={[
                            { label: 'AC', value: 'AC' },
                            { label: 'DC', value: 'DC' },
                          ]}
                          placeholder="Select connector mode"
                          name="connector_mode"
                          value={_.get(values, 'connector_mode')}
                          onChange={(val) => setFieldValue(`connector_mode`, val)}
                          error={errors.connector_mode && touched.connector_mode ? errors.connector_mode : null}
                        />
                      </Col>
                      <Col lg={12}>
                        <Select
                          isRequired
                          label="Connector Standard"
                          options={[
                            { label: 'CHADEMO', value: 'CHADEMO' },
                            { label: 'IEC_60309_2_three_16', value: 'IEC_60309_2_three_16' },
                            { label: 'IEC_62196_T1', value: 'IEC_62196_T1' },
                            { label: 'IEC_62196_T1_COMBO', value: 'IEC_62196_T1_COMBO' },
                            { label: 'GB_T_20234_T3', value: 'GB_T_20234_T3' },
                          ]}
                          placeholder="Select connector standard"
                          name="connector_standard"
                          value={values.connector_standard}
                          onChange={(val) => {
                            setFieldValue(`connector_standard`, val);
                          }}
                          error={errors.connector_standard && touched.connector_standard ? errors.connector_standard : null}
                        />
                      </Col>
                      <Col lg={12}>
                        <TextInput
                          label="Description"
                          as="textarea"
                          rows="4"
                          inputClass="scrollable"
                          placeholder="Description..."
                          name="description"
                          value={_.get(values, 'description', '')}
                          onChange={handleChange}
                          error={errors.description && touched.description ? errors.description : null}
                        />
                      </Col>
                    </Row>
                    <div className="form_btn--block">
                      <Button className="form--btn cancel_btn" onClick={onClose}>
                        Cancel
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form--btn">
                        {isEdit ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
ConnectorTypeForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default ConnectorTypeForm;
